"use strict";
// TODO: 将来新UIに統合されたらThemeProviderからの参照に変更したい
Object.defineProperty(exports, "__esModule", { value: true });
var theme = {
    colors: {
        primary: "#C81D09",
        secondary: "#A66111",
        tertiary: "#24695B",
        quaternary: "#744988",
        quinary: "#325A95",
        white: "#ffffff",
        whiteGray: "#D9DADC",
        gray: "#868B92",
        darkGray: "#323C47",
        black: "#13171A",
        error: "#C81D09",
        warning: "#A66111",
        success: "#24695B",
        info: "#323C47",
    },
    element: {
        hover: "#13171A",
        primary: "#323C47",
        secondary: "#868B92",
        tertiary: "#E0E2E4",
        border: "#C8CDD8",
        form: "#F5F6F8",
        white: "#FFFFFF",
    },
    background: {
        active: "#FFF4F3",
    },
    shadow: "0px 4px 8px rgba(0, 0, 0, 0.24)",
};
exports.default = theme;
